"use client"

import {
  useSidePanel,
  useSidePanelComponent,
  type SidePanelId,
} from "./SidePanelContext"
import { SidePanelShell, type SidePanelShellProps } from "./SidePanelShell"

import type { ReactNode } from "react"

// A SidePanel is the edge-sliding counterpart of Modal: same open-by-id,
// duplicate-detection, and remount-on-open wiring, but driven by its own
// SidePanelContext.
export interface SidePanelProps
  extends Omit<SidePanelShellProps, "open" | "onClose"> {
  id: SidePanelId
  testId?: string
  onClose?: () => void
  children: ReactNode
}

export function SidePanel({
  id,
  testId,
  children,
  onClose,
  ...shell
}: SidePanelProps) {
  const { isOpen, close, mountKey } = useSidePanel(id)

  const onCloseShell = () => {
    onClose?.()
    close()
  }

  useSidePanelComponent(id)

  return (
    <SidePanelShell open={isOpen} onClose={onCloseShell} {...shell}>
      {isOpen && (
        <div data-testid={testId ?? id} key={mountKey} className="h-full">
          {children}
        </div>
      )}
    </SidePanelShell>
  )
}
